import Loading from "./Loading";
import ErrorSign from "./ErrorSign";
import BuyButton from "./BuyButton";
import RescheduleButton from "./RescheduleButton";
import AdminButtons from "./AdminButtons";
import AddEventPopUp from '../components/AddEventPopUp';

function EventScheduler({ isAuthenticated, isLoading, error, chosenDay, filteredEvents, addToCart, rescheduleManager, setRescheduleManager, isInCart, refreshCalendarEvents, setPopUpWindow }) {
  const eventTypes = {
    "individual-class": {
      title: "Individual Class",
      icon: "/event-individual.svg",
      maxParticipants: 1,
      description: <p>Improve your English with personalized classes tailored to your <b>needs</b>, <b>goals</b> and <b>interests</b>. Each class features a topic prepared according to your preferences, focusing on <b>conversational skills</b>, including <b>materials</b> to practice at home.</p>,
    },
    "group-class": {
      title: "Group Class",
      icon: "/event-group.svg",
      maxParticipants: 4,
      description: <p>Practice your <b>conversation skills</b> and learn <b>vocabulary</b> in context. Each class covers a new topic with activities such as <b>discussions</b>, <b>debates</b> and <b>games</b>. After class, additional materials and homework are sent to you to practice at home.</p>,
    },
    "coaching-session": {
      title: "Coaching",
      icon: "/event-coaching.svg",
      maxParticipants: 1,
      description: <p>Individual sessions with personalized guidance for <b>professional</b> or <b>academic</b> success. We focus on your priorities: <b>resume</b> building, <b>interview</b> preparation or <b>presentation</b> skills. Each session offers clear information and practical steps to help you succeed.</p>,
    },
    "custom-event": {
      title: "Event",
      icon: "/event-custom.svg",
      maxParticipants: 4,
      description: <p>No description.</p>
    },
  }

  const instructors = {
    "mc1": {
      name: "Maggie",
      description: <p>Hi! I'm Maggie, an English teacher and educational content creator from the U.S., now living in Chile. I have over 5 years of experience teaching English to adults, focusing on business (meetings and negotiations), travel, and job and scholarship applications. I'm also the founder of Charm English.</p>,
      bullet_points: <ul>
        <li>English teacher from U.S. based in Chile</li>
        <li>5+ years of experience teaching english to adults</li>
        <li>Experience with english for business (meetings and negotiations), travel, and job and scholarship applications</li>
        <li>Founder of Charm English</li>
      </ul>
    },
    "ec1": {
      name: "Emily",
      description: <p>Hi! I'm Emily. I'm an English teacher from the U.S. living in Scotland. I have a Master's in teaching English as a second language and experience tutoring university and graduate students. Formerly an education mediation specialist, I use this experience to create a supportive classroom environment. I'm passionate about linguistics and have lived and studied in Paraguay, Mexico, and Spain. </p>,
      bullet_points: <ul>
        <li>English teacher from the U.S. living in Scotland</li>
        <li>Master's in teaching English as a second language</li>
        <li>Experience tutoring university and graduate students</li>
        <li>Formerly an education mediation specialist</li>
        <li>Passionate about linguistics and has lived and studied in Paraguay, Mexico, and Spain</li>
      </ul>
    },
    "kitty": {
      name: "kitty",
      description: <p>text</p>,
      bullet_points: <ul>
        <li>bullet</li>
        <li>bullet</li>
        <li>bullet</li>
        <li>bullet</li>
      </ul>
    }
  }

  function handleClick(e) {
    setPopUpWindow({
      title: "New Event",
      content: <AddEventPopUp chosenDay={chosenDay} setPopUpWindow={setPopUpWindow} refreshCalendarEvents={refreshCalendarEvents} />,
    });
  }

  function displayInstructor(id) {
    setPopUpWindow({
      title: "Instructor",
      content: 
      <div className="popup--profile">
        <div className="pic--name">
          <img className="profile-pic-2 round-border" src={`/profiles/pp${id}.png`} alt={instructors[id].name} />
          <div className="profile--name">{instructors[id].name} ✨</div>
        </div>
        <div className="profile--description">{instructors[id].description}</div>
        <div className="profile--bullet ok--bullet">{instructors[id].bullet_points}</div>
      </div>,
    })
  }

  function displayEventInfo(event) {
    const startTime = new Date(event.date);

    setPopUpWindow({
      title: eventTypes[event.type].title,
      content: <div className="popup--profile">
      <div className="pic--name">
        <img className="profile-pic-2" src={`${eventTypes[event.type].icon}`} alt={eventTypes[event.type].title} />
        <div className="profile--topic">{event.topic ? event.topic : eventTypes[event.type].title}</div>
      </div>
      <div className="profile--description">
        {event.description ? event.description : eventTypes[event.type].description}
      </div>
      <div className="profile--bullet glitter--bullet">
        <ul>
          <li>Date: {startTime.toLocaleTimeString(undefined, {year: "2-digit", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit"})}</li>
          <li>Duration: {event.duration/60 >= 1 ? Math.floor(event.duration/60) + "h" : ""}{event.duration % 60 === 0 ? "" : " " + (event.duration % 60) + "m"}</li>
          <li>Students: <b>{event.participants}</b> / {event.maxParticipants ? event.maxParticipants : eventTypes[event.type].maxParticipants}</li>
        </ul>
      </div>
    </div>,
    })
  }

  return (
    <div className="event-scheduler--container fade-in-3">
        <div id="event-scheduler" className={`event-scheduler--body${filteredEvents.length > 0 ? " body-available" : ""}`}>
            <div className="event-scheduler--title">
              {isAuthenticated && isAuthenticated.role === "admin" && <button className="event-scheduler--title-add-btn" onClick={handleClick}>+</button>}
              <div className="event-scheduler--title-day">
                <div className="event-scheduler--title-month">{chosenDay.toLocaleDateString('en-US', {month: 'short'}).toUpperCase()}</div>
                <div className="event-scheduler--title-number">{chosenDay.getDate()}</div>
              </div>
              <p>Events</p>
              {filteredEvents.length > 0 && <div className="event-scheduler--title-tag yellow"><b>{filteredEvents.length}</b> Available</div>}
            </div>
            {filteredEvents.length > 0 && <div className={`event-scheduler--message${isAuthenticated.role === "admin" ? " message--admin" : ""}`}>{isAuthenticated.role === "admin" ? <span>Admin View</span> : <span>Times adjusted to your <b>local time zone</b></span>}</div>}
            {isLoading ? <Loading /> : 
              error === true ? <ErrorSign /> : (
                <div className="event-scheduler--list">
                {filteredEvents.length === 0 && <><div className="event-scheduler--list-no-items fade-in-0">No events for this day, choose another date.</div><img className="fade-in-0 empty-kitty" src="/kitty_face.png" alt="Michi :)" width={100} height={100} /></>}
                {filteredEvents.map((event, index) => {
                const startTime = new Date(event.date)
                const startTimeText = startTime.toLocaleTimeString(undefined, {hour: "2-digit", minute: "2-digit"});
                return (<div className={`event-scheduler--event ${event.hidden && "hidden-event"} slide-in-${ index < 4 ? index + 1 : 4 } fade-in-now`} key={index}>
                    {event.hidden && <img className="saved-ribbon" src="/save-ribbon.svg" alt="Saved Event" />}
                    <div className="event-scheduler--event-time">
                      {startTimeText.substring(0,5)}
                      {<p>{startTime.getHours() >= 12 ? "pm" : "am"}</p>}
                    </div>
                    <button className="event-scheduler--event-type" onClick={() => {displayInstructor(event.organizer)}}>
                      <img className="profile-pic" src={`/profiles/pp${event.organizer}.png`} alt={instructors[event.organizer].name} />
                      <div className="event-scheduler--event-type-title">{instructors[event.organizer].name}</div>
                    </button>
                    <button className="event-scheduler--event-duration" onClick={() => {displayEventInfo(event)}}>
                      {eventTypes[event.type].maxParticipants > 1 ? <div className="event-scheduler--event-topic">{event.topic}</div> :
                       <div className="event-scheduler--event-topic">{eventTypes[event.type].title}</div>}
                      <div className="event-scheduler--event-duration-time">
                        <div className="event-duration-time--box">
                          <img src="/clock.svg" alt="Duración"></img>{event.duration/60 >= 1 ? Math.floor(event.duration/60) + "h" : ""}{event.duration % 60 === 0 ? "" : " " + (event.duration % 60) + "m"}
                        </div>
                      </div>
                      <div className="event-scheduler--event-duration-time">
                        <div className="event-duration-time--box">
                          <img src="/user.svg" alt="Inscritos"></img>
                          <div className="event-scheduler--event-participants"><span className="event-participants--counter">{event.participants}</span>/{event.maxParticipants ? event.maxParticipants : eventTypes[event.type].maxParticipants}</div>
                        </div>
                      </div>
                    </button>
                    {isAuthenticated !== false ? 
                      isAuthenticated.role === "admin" ? <AdminButtons event={event} refreshCalendarEvents={refreshCalendarEvents} numParticipants={event.participants} /> :
                      rescheduleManager.prevEvent !== false ? 
                        rescheduleManager.prevEvent.type === event.type ? 
                          rescheduleManager.prevEvent.id !== event._id ?
                            <RescheduleButton setRescheduleManager={setRescheduleManager} event={event} /> :
                            <div className="event-scheduler--buy-btn-placeholder">Rescheduling...</div> : 
                          <div className="event-scheduler--buy-btn-placeholder">Not applicable</div> : 
                        <BuyButton event={event} addToCart={addToCart} isInCart={isInCart} /> : 
                      <BuyButton event={event} addToCart={addToCart} isInCart={isInCart} />}
                  </div>)
                })}
              </div>
            )}
        </div>
    </div>
  )
}

export default EventScheduler;